import { render, staticRenderFns } from "./DadosCorretor.vue?vue&type=template&id=19974869"
import script from "./DadosCorretor.vue?vue&type=script&lang=js"
export * from "./DadosCorretor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports